import SAApi from './_saApi';
import httpClient from '@/apis/base/httpclient';

class SAInvoiceAPI extends SAApi {
  constructor() {
    super();
  }
  controllerName = 'SAInvoices';
  /**
   * Sinh dữ liệu sang chứng từ phiếu thu tiền mặt
   * TPNAM 11.01.2023
   */
  getDataVoucher(payload) {
    let request = {
      url: this.getAPIUrl() + '/DataVoucher',
      data: payload,
    };

    return httpClient.postAsync(request);
  }
}

export default new SAInvoiceAPI();
